import React, { useEffect, useState } from "react";
import axios from "axios";
import Layout from "../components/Layout";
import { Container, Row, Col, Card, ListGroup, Button, Spinner, Table } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import { useNavigate, useLocation } from "react-router-dom";
import appConstants from "../constants/appConstants";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

const getAuthToken = () => localStorage.getItem("authToken");

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const Dashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [firstLoaded, setFirstLoaded] = useState(true);
  const [cashAccounts, setCashAccounts] = useState([]);
  const [bankAccounts, setBankAccounts] = useState([]);
  const [dashboardData, setDashboardData] = useState({
    total_active_students: 0,
    total_collected: 0,
    total_pending: 0,
    recent_transactions: [],
  });
  const [feeChartData, setFeeChartData] = useState({
    labels: [],
    datasets: [
      {
        label: "Fees Collected",
        data: [],
        backgroundColor: "#007bff",
      },
    ],
  });
  const [attendanceChartData, setAttendanceChartData] = useState({
    labels: [],
    datasets: [
      {
        label: "Attendance on",
        data: [],
        backgroundColor: "#007bff",
      },
    ],
  });

  useEffect(() => {
    fetchDashboardData();
    
    const interval = setInterval(fetchDashboardData, 10000); // Poll every 10 seconds
    return () => clearInterval(interval); // Cleanup on unmount
  }, []);
  

  useEffect(() => {
    const handlePopState = (e) => {
      if (location.pathname === '/dashboard') {
        // Prevent navigating back (to login)
        window.history.pushState(null, '', window.location.href);
      }
    };

    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [location]);
  

  const test = async () => {
    try{
      
    const response = await axios.post(
                `https://ilmcampus.in/portal/phpscripts/get-accounts-balance.php`,
                { 
                  start_date: "2024-04-01",
                  end_date: "2025-03-31"
                 },  // JSON payload
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("authToken")}`
                  }
                }
              );

      console.log(response.data);
    } catch (e) {
      console.log(e);
    }
  }

  const fetchCashBankBalances = async () => {
    const token = getAuthToken();
  
    try {
      const response = await axios.post(`${appConstants.API_ROOT_URL}get_cash_bank_balances`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(response.data);
      
      setCashAccounts(response.data.cash_accounts);
      setBankAccounts(response.data.bank_accounts);
    
    } catch (error) {
      console.error("Error fetching cash/bank balances:", error);
    }
  };

  const fetchDashboardData = async () => {
    fetchCashBankBalances();
    setLoading(true);
    const token = getAuthToken();
    if (!token) {
      //alert("Unauthorized! Please log in.");
      navigate("/login");
      return;
    }

    try {
      const response = await axios.post(`${appConstants.API_ROOT_URL}get-dashboard-data`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data.status === "success") {
        setFirstLoaded(false);
        setAttendanceChartData(response.data.data.attendance_chart);
        setFeeChartData(response.data.data.fees_chart);
        setDashboardData(response.data.data);
      }
      else{
        if(response.data.message === "Expired token" || response.data.message === "Invalid or expired token"){
          localStorage.removeItem("authToken");
          localStorage.removeItem("userData");
          navigate("/login");
        }
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
    finally{
      setLoading(false);
    }
  };

  

  

  return (
    <Layout>
      <Container className="mt-4">
        <Row>
          {/* Summary Cards */}
          <Col md={4}>
            <Card bg="primary" text="white" className="shadow">
              <Card.Body>
                <h5><i className="fas fa-users"></i> Total Students</h5>
                <div className="d-flex align-items-center">
                  {firstLoaded & loading ? (
                    <Spinner animation="border" role="status" style={{ color: appConstants.COLORS.BUTTON_COLOR }}>
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                  )
                :
                (
                  <>
                    <h2 className="mb-0 me-2">{dashboardData.total_active_students}</h2>
                    <p className="mb-0">(Appl: {dashboardData.total_application})</p>
                  </>
                )}
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card bg="success" text="white" className="shadow">
              <Card.Body>
                <h5><i className="fas fa-coins"></i> Fees Collected</h5>
                

                {firstLoaded & loading ? (
                    <Spinner animation="border" role="status" style={{ color: appConstants.COLORS.BUTTON_COLOR }}>
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                  )
                :
                (
                  <h2>{dashboardData.total_collected.toLocaleString()}</h2>
                )}

              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card bg="danger" text="white" className="shadow">
              <Card.Body>
                <h5><i className="fas fa-exclamation-circle"></i> Pending Fees</h5>

                {firstLoaded & loading ? (
                    <Spinner animation="border" role="status" style={{ color: appConstants.COLORS.BUTTON_COLOR }}>
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                  )
                :
                (
                  <h2>{dashboardData.total_pending.toLocaleString()}</h2>
                )}

                
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Charts & Recent Activity */}
        <Row className="mt-4">
          <Col md={4}>
            <Card className="shadow">
              <Card.Body>
                <h5><i className="fas fa-chart-line"></i> Fee Collection</h5>
                <Bar data={feeChartData} />
              </Card.Body>
            </Card>
          </Col>
          <Col md={5}>
            <Card className="shadow">
              <Card.Body>
                <h5><i className="fas fa-chart-bar"></i> Class Attendance</h5>
                <Bar data={attendanceChartData} />
              </Card.Body>
            </Card>
          </Col>
          <Col md={3}>
                {(cashAccounts.length > 0 || bankAccounts.length > 0) && (
                  <>
            <Card className="shadow">
              <Card.Body>
                  <h5><i className="fas fa-history"></i> Cash / Bank</h5>
                  
                <Table striped bordered hover size="sm">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Balance</th>
                            </tr>
                          </thead>
                          <tbody>
                            {cashAccounts.length > 0 && cashAccounts.map((item, index) => (
                              <tr key={`cash-${index}`}>
                                <td>{item.name}</td>
                                <td>{item.balance}</td>
                              </tr>
                            ))}

                            {bankAccounts.length > 0 && bankAccounts.map((item, index) => (
                              <tr key={`bank-${index}`}>
                                <td>{item.name}</td>
                                <td>{item.balance}</td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                        </Card.Body>
            </Card>
                        </>
                )}
          </Col>
        </Row>
      </Container>
      {/* Fixed Bottom Bar */}
      <div className="d-none fixed-bottom bg-light p-2" style={{ maxWidth: "calc(100% - 200px)", marginLeft: "200px", borderTop: "1px solid #ddd" }}>
        <Container>
          <Row className="justify-content-around">
            <Col><Button variant="primary" block>Dashboard</Button></Col>
            <Col><Button variant="secondary" block>Students</Button></Col>
            <Col><Button variant="success" block>Fees</Button></Col>
            <Col><Button variant="warning" block>Attendance</Button></Col>
            <Col><Button variant="danger" block>Reports</Button></Col>
            <Col><Button variant="info" block>Settings</Button></Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

export default Dashboard;
